module.exports = __webpack_public_path__ + "img/Bulles_et_confettis.a36a3dd.jpg";